import script from "./Accident.vue?vue&type=script&lang=ts&setup=true"
export * from "./Accident.vue?vue&type=script&lang=ts&setup=true"

import "./Accident.vue?vue&type=style&index=0&id=a1a1ccfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1a1ccfe"]])

export default __exports__